import { SettingsV2 } from '@dixa/messenger-api-payloads';

import { MessengerTranslatedLanguage } from 'components/settings/components/sections/dixaMessenger/views/settings/components/generalSettings/languageSettings/languages';

import {
  KnowledgeState,
  MessengerKnowledgeBaseType,
} from './messengerSettings.types';

export function isKnowledgeSourceIncomplete({
  knowledgeBaseType,
  pristineKnowledgeBaseType,
  elevioIntegration,
  dixaKnowledgeIntegration,
}: Pick<
  KnowledgeState,
  | 'knowledgeBaseType'
  | 'pristineKnowledgeBaseType'
  | 'elevioIntegration'
  | 'dixaKnowledgeIntegration'
>): boolean {
  if (knowledgeBaseType === pristineKnowledgeBaseType) {
    return false;
  }

  return knowledgeBaseType === 'elevio'
    ? elevioIntegration.type === 'not-connected'
    : !dixaKnowledgeIntegration.helpcenterId;
}

export function getFirstKbIntegrationTranslatedLanguage(
  settings: SettingsV2.Settings,
  knowledgeBaseType: MessengerKnowledgeBaseType,
): MessengerTranslatedLanguage | undefined {
  const translations = getKbIntegrationTranslations(
    settings,
    knowledgeBaseType,
  );
  return getFirstTranslatedLanguage(translations);
}

const getFirstTranslatedLanguage = (
  translations: Partial<Record<MessengerTranslatedLanguage, string>>,
): MessengerTranslatedLanguage | undefined => {
  return Object.entries(translations)
    .filter(([_langKey, translation]) => Boolean(translation))
    .map(([langKey]) => langKey as MessengerTranslatedLanguage)[0];
};

function getKbIntegrationTranslations(
  settings: SettingsV2.Settings,
  knowledgeBaseType: MessengerKnowledgeBaseType,
): Partial<Record<MessengerTranslatedLanguage, string>> {
  const kbIntegration =
    knowledgeBaseType === 'dixa_knowledge'
      ? settings.integrations.knowledge
      : settings.integrations.elevio;

  return kbIntegration?.displayType === 'display-button-for-access-to-articles'
    ? (settings.general.findArticles ?? {})
    : (kbIntegration?.searchBarPlaceholder ?? {});
}
